/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface ITestScope extends angular.IScope {
        ajaxPostException(): void;
        javascriptException() : void;
        restartApplicationPool(): void;
        clearReportData(): void;
        regenReportData(): void;
        clearAndRegenReportData(): void;
        clearProcessExecutionData(): void;
        clearProcessCache() : void;
        getProcessInfo(): void;
        getProcessJson(): void;
        processTypes: Wars.Domain.Model.ProcessType[];
        selectedProcessType: Wars.Domain.Model.ProcessType;
        selectedProcessId: string;
        selectedRepordDataProcessType: Wars.Domain.Model.ProcessType;
        includeNativeProcesses: boolean;
        includeConvertedProcesses: boolean;
        processId: string;
        processJson: string;
    }

    export class TestController implements IController {
        constructor(
            private $scope: ITestScope,
            private testService: services.TestService) {

            $scope.includeNativeProcesses = true;
            $scope.includeConvertedProcesses = true;

            $scope.ajaxPostException = () => this.ajaxPostException();
            $scope.javascriptException = () => this.javascriptException();
            $scope.restartApplicationPool = () => this.restartApplicationPool();

            $scope.clearReportData = () => this.clearReportData();
            $scope.clearAndRegenReportData = () => this.clearAndRegenReportData();
            $scope.regenReportData = () => this.regenReportData();
            $scope.clearProcessExecutionData = () => this.clearProcessExecutionData();
            $scope.clearProcessCache = () => this.clearProcessCache();
            $scope.getProcessInfo = () => this.getProcessInfo();
            $scope.getProcessJson = () => this.getProcessJson();

            this.testService.getActiveProcessTypes().then(
                (processTypes) => {
                    this.$scope.processTypes = processTypes;
                });
        }

        private ajaxPostException() : void {
            this.testService.testAjaxPostException().then(() => {
                alert("This success alert should never be displayed!");
            });
        }

        private javascriptException() : void {
            var cody = undefined;
            cody.jump();
        }

        private restartApplicationPool(): void {
            this.testService.unloadAppPool().then(() => {
                alert("Application Pool has been reloaded");
            });
        }

        private getExecutionProcessTypeId(): string {
            return this.$scope.selectedProcessType ? this.$scope.selectedProcessType.id : undefined;
        }

        private getReportProcessTypeId(): string {
            return this.$scope.selectedRepordDataProcessType ? this.$scope.selectedRepordDataProcessType.id : undefined;
        }

      
        private clearReportData(): void {
            this.testService.clearReportData(this.getReportProcessTypeId()).then(() => {
                alert("Report Data has been Cleared");
            });
        }

        private clearAndRegenReportData(): void {
            this.testService.clearAndRegenReportData(this.$scope.selectedProcessId).then(() => {
                alert("Report Data has been Cleared and Marked to be Regenerated for the Specified Process");
            });
        }

        private regenReportData(): void {
            this.testService.regenReportData(this.getReportProcessTypeId()).then(() => {
                alert("Report Data Regeneration Task has been Created");
            });
        }

        private clearProcessExecutionData(): void {
            var vm = {
                processTypeId: this.getExecutionProcessTypeId(),
                includeNativedData: this.$scope.includeNativeProcesses,
                includeConvertedData: this.$scope.includeConvertedProcesses
            };
            this.testService.clearProcessExecutionData(vm).then(() => {
                alert("Process Excecution Data has been Cleared");
            });
        }

        private clearProcessCache(): void {
            this.testService.clearProcessCache().then(() => {
                alert("Process Cache has been Cleared");
            });
        }

        private getProcessInfo(): void {
            this.testService.getProcessInfo().then(() => {
                alert("Process Information written to logs.");
            });
        }

        private getProcessJson(): void {
            this.testService.getProcessJson(this.$scope.processId).then((json) => {
                this.$scope.processJson = json;
            });
        }
    }
}

warsApp.registerController("TestController", ["$scope", "testService"]);